import React, { lazy } from 'react';
import { Route, Switch, useLocation } from 'react-router-dom';

import Loadable from '../ui-component/Loadable';

const AdminLogin     = Loadable(lazy(() => import('../views/admin/Login')));
const AdminDashboard = Loadable(lazy(() => import('../views/admin/Dashboard')));
const ReportDetail   = Loadable(lazy(() => import('../views/admin/ReportDetail')));
const AdminReports   = Loadable(lazy(() => import('../views/admin/Reports')));

const AdminRoutes = () => {
    const location = useLocation();
    return (
        <Route path={['/admin/login', '/admin/dashboard', '/admin/report/:reportId', '/admin/reports']}>
            <Switch location={location} key={location.pathname}>
                <Route path="/admin/login"                  component={AdminLogin} />
                <Route path="/admin/report/:reportId"       component={ReportDetail} />
                <Route path="/admin/reports"                component={AdminReports} />
                <Route path="/admin/dashboard"              component={AdminDashboard} />
            </Switch>
        </Route>
    );
};

export default AdminRoutes;
